<template>
  <div class="tree_condition">
    <condition :filter-value="filterValue" :max-level="3" :questionList="questionList" />
  </div>
</template>

<script>
import Condition from './Condition'
import { getInvestigatorOptions } from '@/api/more-app/investigator-base'
import { randomMixins } from './mixins'
import { baseInfoOptions, investigatorOptions, handleList } from './options'
import { getOrInitInvestigatorSurvey } from '@/api/more-app/investigator-base'
import { getSurveyById } from '@/api/survey'
import { convertQuestion } from '@/question/factory'
import { LeftValueType } from '@/condition/select/types'
import { createNoopCondition } from '@/condition/utils'
import { wjsamplegroupnewGetById } from '@/api/wenjuan/offline'

import {
  checkLogicJump,
  createNoopJumpLogic,
  getLogicList,
  getLogicListByQuestion,
  transformJumpLogic
} from '@/question/logic2/utils'
export default {
  name: 'TreeCondition',
  mixins: [randomMixins],
  components: {
    Condition
  },
  data() {
    const filter = this.getDefaultFilter()
    return {
      conditionSource: {
        baseInfoOptions: [],
        investigatorOptions: [],
        labelOptions: [],
        isFlushing: false
      },
      filter, // 数据副本 用于重置成之前的数据
      filterValue: filter, // 所有数据操作均在此属性内完成
      surveyId: '', // 获取调查员问卷的id
      questionList: [], // 调查员库的题目
    }
  },
  provide() {
    return {
      // 所有远程获取选项的注入
      conditionInject: this.conditionSource,
      // questionList: this.questionList
    }
  },
  inject: {
    params:{
      default: () => ({
        showStatFields: true,
        // group:''
      })
    }
  },
  mounted() {
    this.getSampleList()
  },
  methods: {
    // 添加或者删除key
    addOrDelKey(filter, bool = false) {
      if (bool) {
        filter.groupKey = this.getRandomKey()
        for (const ft of filter.rules) {
          ft.ruleKey = this.getRandomKey()
        }
      } else {
        delete filter.groupKey
        for (const ft of filter.rules) {
          delete ft.ruleKey
        }
      }
      if (Array.isArray(filter.ruleGroups)) {
        for (const rg of filter.ruleGroups) {
          this.addOrDelKey(rg)
        }
      }
    },
    // 给每条数据设置key
    setFilterValueKey(filterValue) {
      const filter = JSON.parse(JSON.stringify(filterValue))
      this.addOrDelKey(filter, true)
      return filter
    },
    // 删除每条数据的key
    removeFilterValueKey(filterValue) {
      this.addOrDelKey(filterValue, false)
      return filterValue
    },
    // 设置filter默认值
    getDefaultFilter() {
      console.log('this.params',this.params)
      return {
        groupKey: this.getRandomKey(),
        conditionRule: 1,
        ruleGroups: [],
        rules: [
          {
            ruleKey: this.getRandomKey(),
            attributeId: -1,
            cascadeIdx: 0,
            classify: Object.keys(this.params).includes('getGroupId') ? 3 : 0,
            fieldName: '',
            params: null,
            type: '',
            condition:createNoopCondition()
          }
        ],
        // condition:{
        //   mainCode: null,
        //   mainQuestionType: null,
        //   subCode: null,
        //   operator: '',
        //   rightOptions: [],
        //   leftValueType: LeftValueType.Default,
        // }
      }
    },
    // 获取样本属性下拉项
    getSampleList() {
      getInvestigatorOptions({ classify: '0' })
        .then(res => {
          const list = res.data?.data || []
          console.log(list)
          this.conditionSource.baseInfoOptions = handleList(list)
        })
        .catch(() => {
          this.$message.error('获取基础信息选项失败')
        })
      getInvestigatorOptions({ classify: '1',showStatFields: this.params.showStatFields })
        .then(res => {
          const list = res.data?.data || []
          this.conditionSource.investigatorOptions = handleList(list)
        })
        .catch(() => {
          this.$message.error('获取调查员属性选项失败')
        })
        if(Object.keys(this.params).includes('getGroupId')){
          wjsamplegroupnewGetById(this.params.getGroupId()).
          then(res=> {
            if(res.data.code === 0){
              const questionList = [];
              res.data.data.pageQuestions.forEach(it=> {
                questionList.push(convertQuestion(it))
              })
              // this.filterValue = {...this.filterValue, questionList, };
              this.questionList = questionList;
            }
          })
          // this.getInvestigatorSurve();
        }else{
          // 获取调查员库中的所有题目
          this.getInvestigatorSurve();

        }
        
        

      // getSampleOptions('2').then((res) => {
      //   const list = res.data?.data || [];
      //   this.conditionSource.labelOptions = list;
      // }).catch(() => {
      //   this.$message.error('获取标签属性选项失败');
      // });
    },
    // 获取调查员题目中的问题
    getInvestigatorSurve(){
      getOrInitInvestigatorSurvey().then(res=> {
        if(res.data.code === 0){
          this.surveyId = res.data.data.id;
        }
      }).then(() => {
        getSurveyById(this.surveyId).then(res=> {
          if(res.data.code === 0){
            const questionList = [];
            res.data.data.pageQuestions.forEach(it=> {
              questionList.push(convertQuestion(it))
            })
            // this.filterValue = {...this.filterValue, questionList, };
            this.questionList = questionList;
          }
        })
      })
    },
    // 设置filter值
    setFilterValue(filter) {
      const formatFilter = this.setFilterValueKey(filter)
      this.filter = JSON.parse(JSON.stringify(formatFilter))
      this.filterValue = JSON.parse(JSON.stringify(formatFilter))
    },
    // 重置filter值
    resetFilterValue() {
      this.filterValue = JSON.parse(JSON.stringify(this.filter))
    },
    // 清除所有filter值
    clearFilterValue() {
      this.filterValue = this.getDefaultFilter()
    },
    // 获取filter值（点确定获取）
    getFilterValue() {
      const filter = this.removeFilterValueKey(this.filterValue)
      this.filter = JSON.parse(JSON.stringify(filter))
      return JSON.parse(JSON.stringify(filter))
    },
    // 刷新标签管理options
    flushLabelOption() {
      this.conditionSource.isFlushing = true
      this.$nextTick(() => {
        this.conditionSource.isFlushing = false
      })
    }
  }
}
</script>

<style lang="scss">
$condition-color: #ccc;
.tree_condition {
  .condition {
    position: relative;
    &::after {
      content: ' ';
      display: block;
      position: absolute;
      top: 40px;
      left: 8px;
      bottom: 12px;
      width: 1px;
      background-color: $condition-color;
    }
  }
  .condition_item,
  .condition_button {
    position: relative;
    &::before {
      content: ' ';
      display: block;
      position: absolute;
      width: 4px;
      height: 4px;
      left: 4.5px;
      top: 12px;
      border-radius: 50%;
      background-color: $condition-color;
      z-index: 1;
      border: 2px solid #fff;
    }
    &::after {
      content: ' ';
      display: block;
      position: absolute;
      height: 1px;
      left: 10px;
      top: 16px;
      width: 24px;
      background-color: $condition-color;
    }
  }
  .condition_button {
    &::before {
      top: 5px;
    }
    &::after {
      top: 8px;
    }
  }
}
.condition_popper_select {
  .el-select-dropdown__list {
    max-width: 200px;
  }
}
</style>
